// extracted by css-extract-rspack-plugin
export default {"addCard":"addCard-T9qCLp"};